import {
  handleLogin,
  handleNewSession,
} from "@/server/controllers/authController";
import { LoginForm } from "@/app/components/auth/LoginForm";
import { getDefaultRedirectForUser } from "@/app/utils/user-redirects";
import { handleFormAction } from "@/app/utils/remix-helpers.server";
import { z } from "zod";

const loginFormSchema = z.object({
  email: z.string().email(),
  password: z.string(),
});

export const action = handleFormAction(
  { form: loginFormSchema },
  async ({ formData, request }) => {
    const session = await handleLogin(request, formData);
    const redirectTo = getDefaultRedirectForUser(session.user);
    return handleNewSession({
      request,
      session,
      redirectTo,
      language: session.user.language,
    });
  }
);

export default function LoginPage() {
  return <LoginForm />;
}
